/**
 * An opaque unique id correlating one AUTH_REQUEST with its reply.
 *
 * `crypto.randomUUID` is the preferred source but is not universally present:
 * it requires a secure context, is missing from jsdom's default window.crypto,
 * and is absent in older Android WebViews — one of this app's two hosts. The
 * fallback only needs uniqueness within a single page session, not
 * cryptographic strength: it is never a secret and never authenticates
 * anything. The origin check is what provides security.
 */
export function newRequestId(): string {
  const c: Crypto | undefined = globalThis.crypto;
  if (typeof c?.randomUUID === "function") return c.randomUUID();
  return `req-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
